var _style, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 153",
    style: {
      enableBackground: "new 0 0 512 153"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000075869208999068233230000010710302695452249759_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.0936,
    y1: 0.3926,
    x2: 51.0936,
    y2: 151.8659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77B3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08759597,
    style: {
      stopColor: "#6EB0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2332,
    style: {
      stopColor: "#54A9DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4177,
    style: {
      stopColor: "#2B9DD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#0091D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000B21"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.9,109.2c-0.7-1.6-2.2-2.6-3.9-2.6c0,0,0,0,0,0l-16.1,0.1L82,84.6c0-2.3-1.8-4.2-4.2-4.2    c-2.3,0-4.2,1.8-4.2,4.2l-0.2,26.3c0,1.1,0.4,2.2,1.2,3c0.8,0.8,1.8,1.2,3,1.2c0,0,0,0,0,0l10.1-0.1l-26.7,26.7l-28.4-28.4    l10.3-0.1c2.3,0,4.1-1.9,4.2-4.2l0.2-32.6c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2H8.5C10.2,41.7,31.7,15.7,62,8.7    c2.3-0.5,3.6-2.8,3.1-5c-0.5-2.3-2.8-3.6-5-3.1c-8.5,2-16.5,5.4-23.9,10.1c-7.2,4.6-13.6,10.3-19,17c-5.4,6.8-9.7,14.3-12.6,22.5    C1.5,58.5,0,67.3,0,76.3c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,2.3,1.9,4.2,4.2,4.2h34.9L38.9,105l-16.2,0.1c-1.7,0-3.2,1-3.8,2.6    c-0.6,1.6-0.3,3.4,0.9,4.5l38.4,38.4c0.8,0.8,1.9,1.2,3,1.2c1.1,0,2.1-0.4,3-1.2l36.9-36.9C102.2,112.6,102.5,110.7,101.9,109.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027565030572591408340000003605680338903150471_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.6933,
    y1: 0.8198,
    x2: 104.6933,
    y2: 152.6074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77B3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08759597,
    style: {
      stopColor: "#6EB0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2332,
    style: {
      stopColor: "#54A9DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4177,
    style: {
      stopColor: "#2B9DD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#0091D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000B21"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027565030572591408340000003605680338903150471_)"
    },
    d: "M155.4,74.6c-0.5-1.8-2.2-3.1-4.1-3    l-34.5,1.1l0.1-24.9l16.2-0.1c1.7,0,3.2-1,3.8-2.6c0.6-1.6,0.3-3.4-0.9-4.5L97.6,2c-1.6-1.6-4.3-1.6-5.9,0L54.8,38.9    c-1.2,1.2-1.6,3-0.9,4.6c0.7,1.6,2.2,2.6,3.9,2.6c0,0,0,0,0,0L73.9,46l-0.1,19.9c0,2.3,1.8,4.2,4.2,4.2c0,0,0,0,0,0    c2.3,0,4.2-1.9,4.2-4.2l0.2-24.1c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.8-1.2-3-1.2c0,0,0,0,0,0L68,37.6l26.7-26.7L123,39.3l-10.3,0.1    c-2.3,0-4.1,1.9-4.2,4.2l-0.2,33.4c0,1.1,0.4,2.2,1.3,3c0.8,0.8,1.8,1.2,2.9,1.2c0,0,0.1,0,0.1,0l34.7-1.1    c-1.7,31-24.2,57.7-54.8,64.3c-2.3,0.5-3.7,2.7-3.2,5c0.4,2,2.2,3.3,4.1,3.3c0.3,0,0.6,0,0.9-0.1c8.7-1.9,16.9-5.2,24.5-9.8    c7.4-4.6,14-10.3,19.5-17.1c5.6-6.8,9.9-14.4,12.9-22.7c3.1-8.5,4.7-17.5,4.7-26.6C155.8,75.7,155.6,75.1,155.4,74.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M187.7,140.4c-1.8-1-3.2-2.4-4.2-4.1c-1-1.8-1.5-3.7-1.5-5.9c0-2.2,0.5-4.1,1.5-5.9c1-1.8,2.4-3.1,4.2-4.1    c1.8-1,3.8-1.5,6.1-1.5c1.7,0,3.2,0.3,4.7,0.8c1.4,0.6,2.6,1.4,3.6,2.5l-1.5,1.5c-1.8-1.8-4-2.7-6.7-2.7c-1.8,0-3.4,0.4-4.9,1.2    c-1.5,0.8-2.6,1.9-3.4,3.4c-0.8,1.4-1.2,3-1.2,4.8c0,1.8,0.4,3.4,1.2,4.8s2,2.5,3.4,3.4c1.5,0.8,3.1,1.2,4.9,1.2    c2.7,0,4.9-0.9,6.7-2.7l1.5,1.5c-1,1.1-2.2,1.9-3.6,2.5c-1.4,0.6-3,0.9-4.7,0.9C191.5,141.9,189.5,141.4,187.7,140.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1,135.7h-12.6l-2.7,6h-2.5l10.3-22.6h2.4l10.3,22.6h-2.5L253.1,135.7z M252.2,133.7l-5.4-12.1l-5.4,12.1H252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.7,121.2c1.6,1.4,2.5,3.3,2.5,5.7c0,2.4-0.8,4.3-2.5,5.7c-1.6,1.4-3.9,2.1-6.8,2.1h-6.1v7.1h-2.4v-22.6h8.5    C305.8,119.1,308,119.8,309.7,121.2z M308,131c1.2-1,1.8-2.4,1.8-4.2c0-1.8-0.6-3.2-1.8-4.2c-1.2-1-2.9-1.5-5.1-1.5h-6v11.3h6    C305.1,132.5,306.8,132,308,131z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,119.1h2.4v22.6h-2.4V119.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.1,121.2h-7.9v-2.1h18.3v2.1h-7.9v20.5h-2.4V121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.6,135.7H443l-2.7,6h-2.5l10.3-22.6h2.4l10.3,22.6h-2.5L455.6,135.7z M454.8,133.7l-5.4-12.1l-5.4,12.1H454.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.9,119.1h2.4v20.5H512v2.1h-15.1V119.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254.7,53.1h20.8v40c-5.3,4-11.5,7.1-18.6,9.3c-7,2.2-14.1,3.2-21.3,3.2c-10.2,0-19.4-2.2-27.6-6.5    c-8.2-4.4-14.6-10.4-19.2-18.2c-4.6-7.7-7-16.5-7-26.2c0-9.8,2.3-18.5,7-26.2c4.6-7.7,11.1-13.8,19.4-18.2    c8.3-4.4,17.5-6.5,27.9-6.5c8.6,0,16.5,1.5,23.5,4.4c7,2.9,12.9,7.1,17.7,12.7l-14.6,13.5c-7-7.4-15.5-11.1-25.5-11.1    c-6.3,0-11.9,1.3-16.7,3.9c-4.9,2.6-8.7,6.3-11.4,11.1c-2.7,4.8-4.1,10.3-4.1,16.5c0,6.1,1.4,11.5,4.1,16.3    c2.7,4.8,6.5,8.5,11.3,11.2c4.8,2.7,10.3,4,16.5,4c6.6,0,12.5-1.4,17.7-4.2V53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,5.4v98.5h-22.8V63.5h-44.8v40.4h-22.8V5.4h22.8v38.8h44.8V5.4H387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.4,99c-8.2-4.4-14.6-10.5-19.3-18.2c-4.6-7.7-7-16.4-7-26.1c0-9.7,2.3-18.4,7-26.1c4.6-7.7,11.1-13.8,19.3-18.2    c8.2-4.4,17.4-6.6,27.7-6.6c10.2,0,19.4,2.2,27.6,6.6c8.2,4.4,14.6,10.5,19.3,18.2c4.7,7.7,7,16.4,7,26.1c0,9.7-2.3,18.4-7,26.1    c-4.7,7.7-11.1,13.8-19.3,18.2c-8.2,4.4-17.4,6.6-27.6,6.6C447.9,105.6,438.6,103.4,430.4,99z M473.9,82.2    c4.7-2.7,8.4-6.4,11-11.2c2.7-4.8,4-10.2,4-16.3c0-6.1-1.3-11.5-4-16.3c-2.7-4.8-6.4-8.5-11-11.2c-4.7-2.7-9.9-4-15.8-4    c-5.8,0-11.1,1.3-15.8,4c-4.7,2.7-8.4,6.4-11,11.2c-2.7,4.8-4,10.2-4,16.3c0,6.1,1.3,11.5,4,16.3c2.7,4.8,6.4,8.5,11,11.2    c4.7,2.7,9.9,4,15.8,4C463.9,86.2,469.2,84.8,473.9,82.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGho);
export default __webpack_public_path__ + "static/media/gho.d88acd86814da13718d97adee24efb7c.svg";
export { ForwardRef as ReactComponent };